module.exports = __webpack_public_path__ + "static/img/SAD-2.3a24624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SAD-2.jpg
// module id = BYvh
// module chunks = 0